import React from "react";
import glamorous from "glamorous";

import RoutingMapView from "../map/RoutingMapView";
import ShipmentDetailPanel from "./ShipmentDetailPanel";

const Section = glamorous.section({
  display: "flex",
  flex: 0.5,
  flexDirection: "column",
  justifyContent: "space-between",
  height: "calc(100vh - 3em)",
  backgroundColor: "white"
});

export default class ShipmentDetailView extends React.Component {
  constructor(props) {
    super(props);

    this.eventHandler = this.eventHandler.bind(this);
  }
  eventHandler(val, type) {
    const { searchLocation } = this.props;

    switch (type) {
      case "LOCATION_LINK":
        searchLocation(val.name, val.id);
        break;
      default:
        break;
    }
  }
  componentDidMount() {
    const { shipmentID, fetchShipmentDetails } = this.props;
    fetchShipmentDetails(shipmentID);
  }

  render() {
    const { shipment, ladsList, locations, H, platform } = this.props;
    const mapProps = { ladsList, H, platform };

    return (
      <glamorous.Div css={{ display: "flex", flexDirection: "row" }}>
        <Section>
          <RoutingMapView
            {...mapProps}
            shipments={[shipment]}
            showBreadCrumbs={true}
            showStopSequence={true}
            eventHandler={this.eventHandler}
          />
        </Section>
        <Section style={{ borderLeft: "1px solid #ddd" }}>
          <ShipmentDetailPanel
            shipment={shipment}
            ladsList={ladsList}
            locations={locations}
          />
        </Section>
      </glamorous.Div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/shipment-detail/ShipmentDetailView.js